// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1UGTt","signatureBlock":"Footer_signatureBlock__15x53","signature":"Footer_signature__ubmfp"};